import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Container = styled.div`
    display: flex;
    margin-bottom: 50px;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-top: 260px;
    padding-bottom: 168px;
    background-color: gray;
    background-size: cover;
    @media only screen and (max-width: 1200px) {
        padding-top: 0;
        padding-bottom: 0px;
        height: 95vh;
    }
`;

export const WrapperSearch = styled.div`
  display: flex;
  flex-direction: column;
  width: 585px;
    @media only screen and (max-width: 486px) {
        width: 90%;
    }
`;


export const Title = styled.h1`
    width: 100%;
    margin: 16px 0;

    ${FONTS.H1};
    
    @media (max-width: 530px) {
        ${FONTS.H3};
    }
`;

export const ButtonCity = styled(Button)`
    margin: 40px auto 3px;
`;
